<template>
  <div>
    <section
      id="page-title"
      class="page-title-dark"
      style="padding: 250px 0; 
        background-image: url('https://infinitydancemiami222222-staging.s3.amazonaws.com/amanda-alvarez2.jpeg'); 
        background-size: cover; 
        background-position: center -1750px;"
      data-stellar-background-ratio="0.2"
    >
      <div class="container clearfix">
        <h1>Student Spotlight</h1>
        <span>2022</span>
      </div>
    </section>
    <section id="content">
      <div class="content-wrap">
        <div class="container clearfix">
          <div class="row clearfix">
            <div class="col-md-12">
              <h3><b> Name: </b> Amanda Alvarez</h3>
              <h3><b> Age: </b> 18</h3>
              <h3><b> Years dancing: </b> 6</h3>

              <h4>
                <b> Future plans: </b> I’m attending Endicott College majoring in political science. Favorite style of dance: contemporary/ballet.
                Graduating performance: I’ll be Performing the main role (Kitri) in the upcoming recital, Don Quijote.
              </h4>
            </div>

            <div class="col-md-12">
              <img src="https://infinitydancemiami222222-staging.s3.amazonaws.com/amanda-alvarez.jpeg" alt="" />
            </div>
            <div class="col-md-12">
              <img src="https://infinitydancemiami222222-staging.s3.amazonaws.com/amanda-alvarez2.jpeg" alt="" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- <div>
      <div class="container clearfix">
        <div class="row">
          <div class="heading-block center topmargin-lg">
            <h3>Previous Spotlights</h3>
          </div>
          <div class="col-md-4 col-sm-8 ">
            <div class="team">
              <div class="team-image">
                <img alt="John Doe" src="@/assets/img/Paty.jpg" />
              </div>
              <div class="team-desc team-desc-bg">
                <div class="team-title">
                  <h4>Patricia Barreiro</h4>
                  <span>Director and Instructor </span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-sm-8 ">
            <div class="team">
              <div class="team-image">
                <img alt="Irasema Berreiro" src="/assets/img/iracema.jpg" />
              </div>
              <div class="team-desc team-desc-bg">
                <div class="team-title">
                  <h4>Irasema Cabrera</h4>
                  <span>Studio Manager and Co-Founder </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'Student Spotlight',
  components: {},
}
</script>
